
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";

@Component({})
export default class KeyManagersAutocomplete extends Vue {

    @Prop({default: null})
    public companyId: number;

    @Prop({default: () => []})
    public keyManagers: any[];

    @Prop({default: () => ["user", "subordinates"]})
    public types: Array<"user"|"subordinates">;

    @Getter private canDoInEnvCompany: (right: string) => boolean;

    private MAX_MANAGERS_DISPLAYED = 5;

    private subordinates: any[] = [];
    private newKeyManagers: any[] = [];
    private search: string = null;

    @Watch("search")
    @Watch("companyId", {immediate: true})
    public handlerSearch() {
      if (this.companyId && this.canDoInEnvCompany("READ_SUBORDINATES")) {
          this.getSubordinatesGroups();
      }
    }

    @Watch("newKeyManagers")
    public handlerNewKeyManagers() {
        this.$emit("update", this.newKeyManagers);
        this.search = null;
    }

    @Watch("keyManagers")
    public handlerKeyManagers() {
        this.newKeyManagers = this.keyManagers;
    }

    private beforeDestroy() {
      this.$emit("update", []);
    }

    private async getSubordinatesGroups(): Promise<void> {
      if (!this.canDoInEnvCompany("READ_SUBORDINATES")) {
        return this.$store.commit("alerts/displayError", {
          msg: this.$t("alerts.error.cantFetchUsers"),
        });
      }
      const p = [];
      if (this.types.includes("user")) {
        p.push(
          this.$store.dispatch("companies/getSubordinates", {
            id: this.companyId,
            query: {
              search: this.search,
              groups: true,
            },
          }),
        );
      }
      if (this.types.includes("subordinates")) {
        p.push(
          this.$store.dispatch("companies/getUserGroups", {
            id: this.companyId,
            query: {
              search: this.search,
              type: "subordinates",
            },
          }),
        );
      }
      await Promise.all(p).then((res) => {
        this.subordinates = res
          .flatMap((r) => r?.list || r?.users || [])
          .map((item: any) => ({...item}));
        });
    }

    private remove(list, item) {
        const pos = list.map((u) => u.id).indexOf(item.id);
        list.splice(pos, 1);
        this.MAX_MANAGERS_DISPLAYED = this.MAX_MANAGERS_DISPLAYED > 5 ? this.MAX_MANAGERS_DISPLAYED - 1 : 5;
    }

    private displayAllUsers(): void {
        const currentDisplayedSize = this.newKeyManagers.length;
        this.MAX_MANAGERS_DISPLAYED = currentDisplayedSize > 5 ? this.newKeyManagers.length : 5;
    }

    private getUserGroupPictureSrc(group: any) {
        return group?.type === "user"
            ? group?.Users?.[0]?.picturePath
            : null;
    }

    private getUserGroupPictureDefaultImg(group: any) {
        return group?.type === "user"
            ? "user"
            : "user-group";
    }
}
